import type { ReactNode } from 'react';
import type { ButtonProperties } from 'ui';
import { Button, Icon, Tooltip, message } from 'ui';
import { routes as routesEhr, useEhrPortalRedirectMutation } from 'features/ehr-portal';

type P = {
  block?: boolean;
  children?: ReactNode;
  size?: ButtonProperties['size'];
  tooltip?: string;
  userId?: string;
};

const EhrUserDetailButton = ({ block, children, size, tooltip, userId }: P) => {
  const { isPending: isRedirectingToEhrPortal, mutate: redirectToEhrPortal } = useEhrPortalRedirectMutation();

  if (!userId) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <Button
        block={block}
        icon={<Icon icon="heartbeat-line" />}
        loading={isRedirectingToEhrPortal}
        onClick={() => {
          message.info('Redirecting to EHR Portal');
          redirectToEhrPortal({ referrer: routesEhr.user.detail(userId) });
        }}
        size={size}
        type="secondary"
      >
        {children}
      </Button>
    </Tooltip>
  );
};

export default EhrUserDetailButton;
